<script>
import { createEventDispatcher } from 'svelte';
import { beforeUpdate, afterUpdate } from 'svelte';

const dispatch = createEventDispatcher();

export let column;
export let row;
export let z;
export let width;
export let height;
export let isCenter;

let tileimg;

afterUpdate(async () => {
    tileimg.classList.remove("visible");
});

function onload(e) {
    tileimg.classList.add("visible");
}
</script>

<style>
.tile {
    position: absolute;
    background: grey;
}
img {
    pointer-events: none;
    opacity: 0;
}
@keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
}

@-moz-keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
}

@-o-keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
}

@-ms-keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
}
.visible {
    opacity: 1;
    animation: fadeIn ease 1s;
    -webkit-animation: fadeIn ease 1s;
    -moz-animation: fadeIn ease 1s;
    -o-animation: fadeIn ease 1s;
    -ms-animation: fadeIn ease 1s;
}
</style>

<div class="tile {isCenter ? "is-center" : ""}" 
    data-column={column} 
    data-row={row} 
    data-z={z} 
    style="transform: translate3d({(column*width)}px, {(row*height)}px, 0px) scale(1); width: {width}px; height: {height}px;">
    <img src="https://tile.openstreetmap.org/{z}/{column}/{row}.png" bind:this={tileimg}
            on:load={onload}
            alt="Map tile {z}/{column}/{row}" 
            draggable="false" 
            class="noselect visible" />
</div>